import React, { Component } from 'react'

export default class AboutUs extends Component {
    render() {
        return (
             <div className="about-us" id="about-us">
                <h1 className="mb-3">
                    Wer sind wir?
                </h1>
                <h4>
                    Mission
                </h4>
                <p className="mb-3">
                    Die Innovationskraft im Eisenbahnsektor durch die Förderung einheimischer Technologien und einer starken F&E-Kultur vorantreiben.
                </p>
                <h4 >
                    Vision
                </h4>
                <p>
                    Ein führendes Unternehmen werden, das die Abhängigkeit der Türkei vom Ausland im Eisenbahnsektor verringert und lokale Lösungen weltweit exportiert.
                </p>
            </div>
        )
    }
}
